import { keyframes } from '@emotion/react';
import { merge } from 'lodash/fp';

import oldTheme from './deprecatedTheme';

export const BREAKPOINTS = [768, 992, 1200];

export const MediaQueries = {
    mobile: `(max-width: ${BREAKPOINTS[0] - 1}px)`,
    tablet: `(min-width: ${BREAKPOINTS[0]}px)`,
    laptop: `(min-width: ${BREAKPOINTS[1]}px)`,
    desktop: `(min-width: ${BREAKPOINTS[2]}px)`,
};

export default merge(oldTheme, {
    zIndex: {
        rowsPerPage: 1,
        pageHeader: 2,
        dropdownMenus: 3000,
        popovers: 3500,
        popups: 4000,
        backdrop: 4500,
        modal: 5000,
    },
    media: {
        mobile: `@media screen and ${MediaQueries.mobile}`,
        tablet: `@media screen and ${MediaQueries.tablet}`,
        laptop: `@media screen and ${MediaQueries.laptop}`,
        desktop: `@media screen and ${MediaQueries.desktop}`,
    },
    typography: {
        fontFamily: {
            medium: '"Avenir", "Arial", sans-serif',
            roman: '"Avenir", "Arial", sans-serif',
            book: '"Avenir", "Arial", sans-serif',
            heavy: '"Avenir", "Arial", sans-serif',
        },
        fontWeight: {
            base: 400,
            medium: 500,
            bold: 700,
        },
    },
    color: {
        // color palette from sketch design
        white: '#FFFFFF',
        white30: '#FFFFFF48',
        gray40: '#A2A3A4',
        gray70: '#5B5E5F',
        gray90: '#2C2F31',
        gray95: '#212427',
        gray15: '#DFE0E0',
        jetBlack: '#16191C',
        green1: '#1FBA59',
        green2: '#CBED8C',
        red: '#D73146',
        purple: '#7B00E8',

        // Status - used for Form Validation and Alerts
        error: '#D73146',
        warning: '#F09536',
        success: '#1FBA59',
        info: '#2B88D8',
        text: '#F7F8F8',

        // disabled state colors
        disabled: '#A2A3A4',
        disabledText: '#5B5E5F',

        // background surface of component (e.g. Card, Menu, Header, Label, Input, Dropdown Option)
        surfaceText: '#16191C',
        surfaceIcon: '#16191C',
        surface: '#F4F5F5',
        surface2: '#F9FAF9',

        // base variation of component (e.g. Button, Dropdown)
        baseText: '#1FBA59',
        baseIcon: '#1FBA59',
        base1: '#FFF',
        base2: '#1FBA59',
        base3: '#1DAA52',

        // more important variation of component (PrimaryButton)
        primaryText: '#FFF',
        primaryIcon: '#FFF',
        primary1: '#1FBA59',
        primary2: '#1DAA52',
        primary3: '#1C9B4C',

        // less important variation of component (SecondaryButton)
        secondaryText: '#16191C',
        secondaryIcon: '#16191C',
        secondary1: '#F0F2F1',
        secondary2: '#EAECEE',
        secondary3: '#E2E4E6',

        tertiaryText: '#16191C',
        tertiaryIcon: '#A2A3A4',
        tertiary1: 'linear-gradient(to top, #E8EAE9, #F0F2F1)',
        tertiary2: '#E2E4E6',
        tertiary3: '#5B5E5F',

        // destructive variation of component, like delete (DangerButton)
        dangerText: '#FFF',
        dangerIcon: '#FFF',
        danger1: '#dc3545',
        danger2: '#c82333',
        danger3: '#bd2130',

        backgroundGray: '#F0F2F1',
        tableZebraStripeGray: '#F7F8F8',
        backdropBackground: 'rgba(0, 0, 0, 0.3)',
    },
    boxShadow: {
        base1: 'unset',
        primary1: '0 4px 12px rgba(31, 186, 89, 0.3)',
        danger1: '0 4px 12px rgba(194, 48, 66, 0.3)',
        surface: '0px 0px 8px rgba(0, 0, 0, 0.15)',
    },
    gradients: {
        green1: 'linear-gradient(180deg, #3AD786 0%, #1FBA59 100%)',
        green2: 'linear-gradient(180deg, rgb(58, 215, 134, 0.1) 0%, rgb(31, 186, 89, 0.1) 100%)',
        tertiary1: 'linear-gradient(to top, #E8EAE9, #F0F2F1)',
    },
    border: {
        base: '2px solid #1FBA59',
        surface: '1px solid #A2A3A4',
        tableRowSeparator: '1px solid #ECEDED',
    },
    borderRadius: {
        base: 4,
    },
    animations: {
        fadeIn: keyframes({ from: { opacity: 0 }, to: { opacity: 1 } }) + ' 0.5s forwards',
        spin:
            keyframes({
                from: { transform: 'rotate(0deg)' },
                to: { transform: 'rotate(360deg)' },
            }) + ' 2s linear infinite',
    },
    minWidth: {
        window: 740,
        navigation: 270,
        navigationMinimized: 60,
    },
    maxWidth: {
        window: 1200,
    },
    wrapLongText: {
        width: '100%',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
    },
});
